const wordCarousels = document.querySelectorAll('.words-carousel')

wordCarousels.forEach(function (element, index) {
  const carousel = element
  const delay = parseInt((carousel.dataset.duration ?? 5) * 1000)

  let elements = carousel.querySelectorAll('div.words-carousel-word')
  let h = 0;
  [...elements].map((element) => {
    let eh = element.getBoundingClientRect().height
    if (eh > h) {
      h = eh
    }
  })

  let p = parseInt(
    window.getComputedStyle(carousel).getPropertyValue('padding-top'),
  )
  h += p * 2
  carousel.style.height = `${h}px`

  function animateNext() {
    let bump = carousel.querySelector('div.bump')
    let last = carousel.querySelector('div:not(.bump).animate')
    let next = carousel.querySelector('div:not(.animate)')

    if (bump) {
      bump.classList.remove('bump', 'animate')
      carousel.appendChild(bump)
    }

    if (last) {
      last.classList.add('bump')
    }

    next.classList.add('animate')
    setTimeout(animateNext, delay)
  }
  animateNext()
})
